import CheckNamespaceAdminRequest from '@/api/Main/dataSource/api/projects/performers/i-service/model/namespace-admins/CheckNamespaceAdminRequest';
import ApiService from '@/api';
import CheckProjectAdminRequest from '@/api/Main/dataSource/api/projects/performers/i-service/model/project-admins/CheckProjectAdminRequest';
import GetAccessCurrentUserInQueueTaskByIdRequest from '@/api/Main/dataSource/api/projects/performers/i-service/model/queue-task/request/GetAccessCurrentUserInQueueTaskByIdRequest';
import GetQueueTaskEmployeeListDetailRequest from '@/api/Main/dataSource/api/projects/performers/i-service/model/queue-task/request/GetQueueTaskEmployeeListDetailRequest';
import { mapGetUsersAccessResponse } from '@/components/edit-queue-modal/adapter-service/adapter-service.mappers';
import { EmployeeAccessModel } from '@/components/edit-queue-modal/models';
import { TirPmNotificationEventBus, TirPmNotificationModel } from 'tir-components';
import { ResponseModel } from 'tir-pm-file-upload-manager';
import GetAccessCurrentUserInQueueTaskByIdResponse from '@/api/Main/dataSource/api/projects/performers/i-service/model/queue-task/response/GetAccessCurrentUserInQueueTaskByIdResponse';
import { CurrentUser, UserRoleEnum } from 'tir-pm-user-core';

/**
 * Сервис для работы c правами доступа текущего пользователя
 */
export class AccessAdapterService {
  private readonly api = new ApiService();
  IsNamespaceAdmin: boolean = false;
  IsProjectAdmin: boolean = false;
  QueueUsersRoles: EmployeeAccessModel[] = [];
  AccessCurrentUserInQueueTaskById: GetAccessCurrentUserInQueueTaskByIdResponse =
    new GetAccessCurrentUserInQueueTaskByIdResponse();

  async isNamespaceAdmin(req: CheckNamespaceAdminRequest): Promise<ResponseModel<Boolean>> {
    const result = new ResponseModel<Boolean>();
    try {
      const response = await this.api.Main.NamespaceAdminRoleService.checkNamespaceAdminAsync(req);
      result.Value = response.IsNamespaceAdmin;
      this.IsNamespaceAdmin = response.IsNamespaceAdmin;
    } catch (e) {
      result.IsSuccess = false;
      result.ErrorCode = e?.ErrorCode;
      result.ErrorMessage = e?.ErrorMessage;
      this.sendErrorNotification(result.ErrorMessage);
      console.error('ERROR checkNamespaceAdminAsync', e);
    }

    return result;
  }

  async isProjectAdmin(req: CheckProjectAdminRequest): Promise<ResponseModel<Boolean>> {
    const result = new ResponseModel<Boolean>();

    try {
      const response = await this.api.Main.ProjectAdminRoleService.checkProjectAdminAsync(req);
      result.Value = response.IsProjectAdmin;
      this.IsProjectAdmin = response.IsProjectAdmin;
    } catch (e) {
      result.IsSuccess = false;
      result.ErrorCode = e?.ErrorCode;
      result.ErrorMessage = e?.ErrorMessage;
      this.sendErrorNotification(result.ErrorMessage);
      console.error('ERROR checkProjectAdminAsync', e);
    }

    return result;
  }

  async getQueueUsersRoles(
    req: GetQueueTaskEmployeeListDetailRequest,
  ): Promise<ResponseModel<EmployeeAccessModel[]>> {
    const result = new ResponseModel<EmployeeAccessModel[]>();

    try {
      const response =
        await this.api.Main.QueueTaskAdminRoleService.getQueueTaskEmployeeListDetailAsync(req);
      result.Value = mapGetUsersAccessResponse(response);
      this.QueueUsersRoles = result.Value;
    } catch (e) {
      result.IsSuccess = false;
      result.ErrorCode = e?.ErrorCode;
      result.ErrorMessage = e?.ErrorMessage;
      this.sendErrorNotification(result.ErrorMessage);
      console.error('ERROR getQueueTaskEmployeeListDetailAsync', e);
    }

    return result;
  }

  async getUserAccess(
    req: GetAccessCurrentUserInQueueTaskByIdRequest,
  ): Promise<ResponseModel<Boolean>> {
    const result = new ResponseModel<Boolean>();

    try {
      const response =
        await this.api.Main.QueueTaskAdminRoleService.getAccessCurrentUserInQueueTaskByIdAsync(req);
      this.AccessCurrentUserInQueueTaskById = new GetAccessCurrentUserInQueueTaskByIdResponse(
        response,
      );
      result.Value =
        response.IsAdmin ||
        response.EmployeeQueueTaskAccesses?.includes(1) ||
        response.EmployeeQueueTaskAccesses?.includes(2) ||
        CurrentUser.Roles.includes(UserRoleEnum.Owner);
      // (VisibilityOtherTask = 0),
      //   (CreateTask = 1),
      //   (UpdateOtherTask = 2),
      //   (FinallyEstimate = 3),
    } catch (e) {
      result.IsSuccess = false;
      result.ErrorCode = e?.ErrorCode;
      result.ErrorMessage = e?.ErrorMessage;
      this.sendErrorNotification(result.ErrorMessage);
      console.error('ERROR getAccessCurrentUserInQueueTaskByIdAsync', e);
    }

    return result;
  }

  /**
   * * Получение доступов по текущему пользователю в очереди задач по идентификатору
   */
  async getAccessCurrentUserInQueueTaskById(
    request: GetAccessCurrentUserInQueueTaskByIdRequest,
  ): Promise<ResponseModel<GetAccessCurrentUserInQueueTaskByIdResponse>> {
    return new Promise<ResponseModel<GetAccessCurrentUserInQueueTaskByIdResponse>>(
      async (resolve) => {
        const result = new ResponseModel<GetAccessCurrentUserInQueueTaskByIdResponse>();
        try {
          const response =
            await this.api.Main.QueueTaskAdminRoleService.getAccessCurrentUserInQueueTaskByIdAsync(
              request,
            );
          result.Value = response;
          resolve(result);
        } catch (e) {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR', e);
          return result;
        }
      },
    );
  }

  /**Отправка уведомления об ошибке */
  sendErrorNotification(message: string) {
    TirPmNotificationEventBus.emit(
      'add',
      new TirPmNotificationModel({
        title: message,
        type: 'error',
        group: 'general',
        life: 5000,
        closable: true,
        callbackButton: () => {},
      }),
    );
  }
}
